/** OpenTelemetry config from CRA / env-cmd (REACT_APP_OTEL_* / OTEL_*). */

/** Align with paperfly-rest / paperfly-worker resource tags (not semconv `.name`). */
export const OTEL_ATTR_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';

function readEnv(key) {
  // Dynamic process.env[key] works only for keys embedded on CRA's process.env object.
  const value = process.env[key];
  return value && !String(value).includes('${') ? String(value) : '';
}

export function getOtelEndpoint() {
  const raw =
    readEnv('REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT') ||
    readEnv('OTEL_EXPORTER_OTLP_ENDPOINT') ||
    readEnv('REACT_APP_OTEL_URL');
  return String(raw || '').replace(/\/$/, '');
}

export function getOtelServiceName() {
  return (
    readEnv('REACT_APP_OTEL_SERVICE_NAME') ||
    readEnv('OTEL_SERVICE_NAME') ||
    readEnv('REACT_APP_NAME') ||
    'paperfly-pwa'
  );
}

export function getOtelAuthorization() {
  const explicit =
    readEnv('REACT_APP_OTEL_AUTHORIZATION') || readEnv('OTEL_AUTHORIZATION');
  if (explicit && !explicit.includes('${')) {
    return explicit;
  }
  const token = readEnv('REACT_APP_OTEL_TOKEN') || readEnv('OTEL_TOKEN');
  return token ? `Bearer ${token}` : '';
}

export function getOtelEnvironment() {
  return (
    readEnv('REACT_APP_OTEL_DEPLOYMENT_ENVIRONMENT') ||
    readEnv('OTEL_DEPLOYMENT_ENVIRONMENT') ||
    readEnv('REACT_APP_ENV') ||
    'local'
  );
}

export function getOtelServiceVersion() {
  return readEnv('REACT_APP_VERSION') || '';
}

export function isOtelConfigured() {
  const endpoint = getOtelEndpoint();
  if (!endpoint) return false;
  // Shared Paperfly collector needs auth — no token ⇒ stay silent (avoids
  // local/pre-prod noise). Local collectors (e.g. Jaeger :4318) need no token.
  if (/otel\.paperfly\.io/i.test(endpoint)) {
    return Boolean(getOtelAuthorization());
  }
  return true;
}

/** OTLP HTTP traces URL */
export function getOtelTracesUrl() {
  const endpoint = getOtelEndpoint();
  if (!endpoint) return '';
  if (endpoint.endsWith('/v1/traces')) return endpoint;
  return `${endpoint}/v1/traces`;
}
